query GlobalAppCtaQuery($site: [String!]) {
  globalSet(site: $site, handle: "appCta") {
    ... on appCta_GlobalSet {
      heading
      teaserText
      image {
        url
        width
        height
        title
      }
      imageOverlap
      alt
    }
  }
}
